export default "__VITE_ASSET__PYC59WSv__"